// A numeric character reference (an editor writes ' as &#39; or &#x27;), read as one character of a
// default so its # does not end the token.
const CHARACTER_REFERENCE = '&#(?:\\d{1,7}|[xX][0-9a-fA-F]{1,6});';

/**
 * Whether a text holds a variable, written `#Key#` or with a default text, `#Key|Default text#`.
 * A default is read the way the server's tokenPattern (TemplateConditions.SPEC.defaults) reads it:
 * up to 500 characters, none of them # < > or a line break, ending in a character that is not a
 * space (or in a numeric character reference), and its closing # not followed by a letter or digit.
 * Anything else, like `#Key|our page #` or `#Key|our page#2026`, the server leaves as text, so it
 * does not count. `#Key#` counts wherever it stands. Case-insensitive, like the render.
 *
 * @param token the variable as `#Key#`
 */
export function hasVariableToken(text: string | null | undefined, token: string): boolean {
  const key = String(token || '').replace(/^#|#$/g, '');
  if (!text || !key) {
    return false;
  }
  const escaped = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const character = `(?:${CHARACTER_REFERENCE}|[^#<>\\r\\n])`;
  const last = `(?:${CHARACTER_REFERENCE}|[^#<>\\s])`;
  return new RegExp(`#${escaped}(?:#|\\|${character}{0,499}${last}#(?![A-Za-z0-9]))`, 'i').test(text);
}
